<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <h2>DAC6 Registration</h2>
          <p>
            This DAC6 tool can be used to determine whether an arrangement must be reported in accordance with the DAC6
            Directive and relevant local legislation, and the result is stored centrally. In the overview below, click
            on the relevant questionnaire below to finalise a questionnaire that has not yet been completed or to view
            the preliminary conclusions of a questionnaire that has been completed. Alternatively, click on “New
            registration” to determine whether a new arrangement may be reportable.
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex">
          <v-btn depressed height="40px" color="bdoRed white--text" class="text-none mr-2" @click="NewRegistration">
            NEW REGISTRATION
          </v-btn>
          <v-btn
            :loading="btnLoading"
            depressed
            height="40px"
            color="bdoRed white--text"
            class="text-none mr-auto"
            @click="refreshPage"
          >
            REFRESH
          </v-btn>

          <v-text-field
            v-model="tableSearch"
            label="Search"
            prepend-inner-icon="mdi-magnify"
            class="tableSearch"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <data-table
            class="data-table"
            :headers="tableHeaders"
            :table-content="questionnaires"
            :sort-by="sortBy"
            :table-search="tableSearch"
            @rowClick="tableRowClick"
            :table-options="tableOptions"
            :filters="tableFilters"
            data-name="data"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import helpers from '@/plugins/helpers'
import { mapGetters } from 'vuex'
import dataTable from '@/components/data-table.vue'
import config from '@/config'
export default {
  components: {
    dataTable
  },
  data: () => ({
    questionnaires: [],
    tableHeaders: [
      { id: 0, text: 'Client', value: 'client_name' },
      { id: 1, text: 'Client number', value: 'client_number' },
      { id: 2, text: 'Registration date', value: 'registration_date', type: 'date' },
      { id: 3, text: 'Status', value: 'status' },
      { id: 4, text: 'Reporting obligation', value: 'reporting_obligation' },
      { id: 5, text: 'Start 30-day-period', value: 'period', type: 'date' },
      { id: 6, text: 'Description of arrangement', value: 'arrangement' },
      { id: 7, text: 'Id', value: 'id' },
      { id: 8, text: 'Registration by', value: 'registration_by' }
    ],
    sortBy: 'Prio',
    tableOptions: {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      sortOrder: 'asc'
    },
    tableFilters: { name: [], client: [] },
    take: 200,
    skip: 0,
    btnLoading: false,
    tableSearch: ''
  }),
  computed: {
    ...mapGetters({
      user: 'general/user',
      countrycode: 'general/countrycode'
    })
  },
  mounted() {
    //this.checkUser()
    this.getTableDataInit()
  },
  methods: {
    getTableDataInit() {
      this.questionnaires = []
      this.skip = 0
      this.getTableData()
    },
    async checkUser() {
      if (!this.user.id || this.user.id == null) {
        let userProfile = await helpers.fetchApi(config.apiUrl + 'authentication/user', 'get')
        if (userProfile) {
          this.$store.commit('SET_USER', userProfile)
        }
      }
    },
    async getTableData() {
      let query = `{
         allCustomerquestionnaire(take: 200, skip: ${this.skip}, sort: { field: createdAt, order: DESC }){
          results{
            id
            customer{
              relationNumber
              companyName
            }
            webUser{
              name
            }
            createdAt
            status
            finalAdvice
            taskRemark
            implementationDate
          }
          totalCount
        }
      }`
      let result = await helpers.fetchGraph(query)
      if (result) this.formatTableData(result)
    },
    formatTableData(result) {
      let arr = []
      let resultObj = result.data[Object.keys(result.data)[0]]
      arr = resultObj.results.map(x => ({
        id: x.id,
        client_name: x.customer ? x.customer.companyName : '',
        client_number: x.customer ? x.customer.relationNumber : '',
        registration_date: x.createdAt,
        status: x.status,
        reporting_obligation: x.finalAdvice,
        period: x.implementationDate,
        arrangement: x.taskRemark && x.taskRemark.length > 50 ? x.taskRemark.substring(0, 50) + '...' : x.taskRemark,
        registration_by: x.webUser ? x.webUser.name : ''
      }))
      for (let i = 0; i < arr.length; i++) {
        this.questionnaires.push(arr[i])
      }
      if (resultObj.totalCount > this.questionnaires.length) {
        this.skip = this.skip + this.take
        this.getTableData(result)
        return
      } else {
        this.skip = 0
      }
    },
    tableRowClick(item) {
      if (!item) return
      if (item.status === 'Open' || item.status === 'In review')
        this.$router.push({ path: `/${this.countrycode}/questionnaire/${item.id}` })
      else this.$router.push({ path: `/${this.countrycode}/reporting-obligation/${item.id}` })
    },
    NewRegistration() {
      this.$router.push({ path: `/${this.countrycode}/registration` })
    },
    refreshPage() {
      this.btnLoading = true
      location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.tableSearch {
  max-width: 200px;
}
</style>
